module.exports = __webpack_public_path__ + "img/optel-geot.dc847f83.png";